/* eslint-disable @typescript-eslint/no-explicit-any */
/* This is due to react-papaparse not being fully typescript yet. */
import { chain, map } from "lodash";
import moment from "moment";
import React, { useContext } from "react";
import { useCSVDownloader, useCSVReader } from "react-papaparse";
import GratefulDB from "../../GratefulDB";
import GratefulDBContext from "../../GratefulDBContext";
import SearchResultItem from "../shared/SearchResultItem";
import { useFavorites } from "../shared/useFavorites";
import "./Favorites.scss";

const Favorites: React.FC = (): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const favoritesImage = require(`../../images/${process.env.REACT_APP_FAVORITES_IMAGE}`);

  const favorites = useFavorites();
  const gratefulDB = useContext<GratefulDB>(GratefulDBContext);
  const { CSVDownloader } = useCSVDownloader();
  const { CSVReader } = useCSVReader();

  const results = chain(favorites.get())
    .map((id) => gratefulDB.get(id))
    .compact()
    .sortBy((e) => Date.parse(e.date))
    .value();

  const getCSVData = () =>
    map(favorites.get(), (id) => {
      return {
        identifier: id,
      };
    });

  const randomHex = () => Math.floor(Math.random() * 16777215).toString(16);

  const csvFilename = () =>
    `${process.env.REACT_APP_NAME}.backup.${moment().format(
      "YYYY.MM.DD"
    )}.${randomHex()}`;

  const uploadAccepted = (data: any) => {
    const identifiers = chain(data.data)
      .drop(1)
      .filter((row) => gratefulDB.get(row[0]))
      .map((row) => row[0])
      .value();

    if (identifiers.length > 0) {
      favorites.import(identifiers);
    }
  };

  const noFavorites = (
    <div className="ui center aligned container no-favorites">
      <img
        className="ui centered image"
        src={favoritesImage}
        alt="Billy and the Kids!"
      />
      <h1 className="ui header">
        No favorites right now.
        <div className="sub header">Do you really listen to this band?</div>
      </h1>
    </div>
  );

  return (
    <div className="ui container Favorites">
      <h2 className="ui header favorites-header">
        <i className="heart icon" />
        <div className="content">
          <CSVDownloader
            bom={true}
            data={getCSVData()}
            filename={csvFilename()}
          >
            <button className="right floated ui teal basic huge icon button">
              <i className="download icon"></i>
            </button>
          </CSVDownloader>
          <CSVReader onUploadAccepted={uploadAccepted}>
            {({ getRootProps }: any) => (
              <button
                className="right floated ui teal basic huge icon button"
                {...getRootProps()}
              >
                <i className="cloud upload icon"></i>
              </button>
            )}
          </CSVReader>
          <div className="header">Favorites</div>
          <div className="sub header">We call them &quot;your picks&quot;.</div>
        </div>
      </h2>
      <div className="ui divider" />
      <div className="ui divided link items">
        {results.map((entry) => (
          <SearchResultItem entry={entry} key={entry.identifier} />
        ))}
      </div>
      {!results.length ? noFavorites : null}
    </div>
  );
};

export default Favorites;
